import { osChrome } from "fleet/constant/os-platform";
import { ConnectedScreenshotBox } from "fleet/controller/device/connected-screenshot";
import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { NavLoader } from "ui/loader";
import { Box } from "view/layout/box";

import { DiskChart } from "./chart-disk";
import { MemoryChart } from "./chart-memory";
import { NetworkChart } from "./chart-network";
import { DevicesLocationMap } from "./map";

class DeviceDetailsPage extends React.PureComponent {
  static get propTypes() {
    return {
      applications: PropTypes.object.isRequired,
      device: PropTypes.object.isRequired,
      deviceId: PropTypes.string.isRequired,
      deviceStatus: PropTypes.object.isRequired,
      loadDeviceResources: PropTypes.func.isRequired,
      resources: PropTypes.object.isRequired,
      storesLoaded: PropTypes.bool.isRequired,
      unloadDeviceResources: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      allHours: 1,
      diskHours: 1,
      memoryHours: 1,
      networkHours: 1,
    };

    this.fetchResources();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.device !== this.props.device) {
      this.fetchResources();
    }
  }

  fetchResources(type = "all", hours = 1) {
    const { deviceId, loadDeviceResources } = this.props;

    if (!deviceId) {
      return;
    }

    return loadDeviceResources(deviceId, type, hours).then(() => {
      const newState = {
        [type + "Hours"]: hours,
      };

      this.setState(newState);
    });
  }

  componentWillUnmount() {
    const { unloadDeviceResources } = this.props;

    unloadDeviceResources();
  }

  _renderDateButtons(type) {
    return (
      <div className="resource-dates-wrapper">
        <Button
          size="xsmall"
          className="resource-date-btn"
          active={this.state[type + "Hours"] === 24 * 7}
          onClick={() => this.fetchResources(type, 24 * 7)}
        >
          Last 7 Days
        </Button>
        <Button
          size="xsmall"
          className="resource-date-btn"
          active={this.state[type + "Hours"] === 24}
          onClick={() => this.fetchResources(type, 24)}
        >
          Last 24 Hours
        </Button>
        <Button
          size="xsmall"
          className="resource-date-btn"
          active={this.state[type + "Hours"] === 1}
          onClick={() => this.fetchResources(type, 1)}
        >
          Last Hour
        </Button>
      </div>
    );
  }

  render() {
    const { applications, device, deviceStatus, resources, storesLoaded } =
      this.props;

    if (!storesLoaded) {
      return <NavLoader.Proxy />;
    }

    if (!device) {
      return null;
    }

    const { disk = [], memory = [], network = [] } = resources;

    const online = Boolean(deviceStatus.online);
    const isChromeOS = Boolean(device.os_platform === osChrome.id);

    return (
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={6}>
              <DevicesLocationMap devices={[device]} />
            </Col>
            <Col xs={6}>
              <ConnectedScreenshotBox
                device={device}
                online={online}
                isChromeOS={isChromeOS}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Box title="Memory Usage per Application (MB)">
                {this._renderDateButtons("memory")}
                <MemoryChart applications={applications} data={memory} />
              </Box>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Box title="Network Usage">
                {this._renderDateButtons("network")}
                <NetworkChart device={device} data={network} />
              </Box>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Box title="Disk Usage Percentage">
                {this._renderDateButtons("disk")}
                <DiskChart device={device} data={disk} />
              </Box>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export { DeviceDetailsPage };
